import { useFormContext } from 'react-hook-form';
import { LendingFormConfig } from './types';

const useLendingFormContext = () => {
  return useFormContext<LendingFormConfig>();
};

export default useLendingFormContext;
